import React from "react";
import s from "./Placeholder.module.scss";

const Placeholder = ({ children }) => {
  return <div className={s.placeholder}>{children}</div>;
};

export default Placeholder;
